import { createFocusTrap } from 'focus-trap'; // ESM
import { disablePageScroll, enablePageScroll } from 'scroll-lock';

export default {
    init() {
        let modal_buttons = document.querySelectorAll('button.modal-button').forEach(modal_button => {
            let content = modal_button.parentElement.nextElementSibling.querySelector('.modal-content');
            if(!content) {
                throw new Error("modal.js - Error, modal-content not found.");
            }

            let focus = createFocusTrap(modal_button.nextElementSibling);
            //when the modal button is clicked open the modal, which should be the next element.
            modal_button.addEventListener('click', () => {
                modal_button.parentElement.nextElementSibling.classList.add('active');
                focus.activate();
                disablePageScroll(content);
            })

            modal_button.parentElement.nextElementSibling.querySelector('.exit').addEventListener('click', e => {
                let curr_modal = document.querySelector('.modal.active');
                if(curr_modal) {
                    curr_modal.classList.remove('active');
                    focus.deactivate();
                    enablePageScroll(content)
                }
            })
        })
    }
}